/**
 * Green Flag — UpcomingEligibleWidgetSkeleton
 *
 * Loading placeholder for the Events page top widget. Reuses the
 * `upcomingEligibleWidget` slot recipe so it matches {@link UpcomingEligibleWidget}'s
 * vertical card shape (hero image on top, date / title / button stacked below).
 * Non-interactive.
 */

import { Box, Skeleton, chakra, useSlotRecipe } from "@chakra-ui/react";

export function UpcomingEligibleWidgetSkeleton() {
  const recipe = useSlotRecipe({ key: "upcomingEligibleWidget" });
  const styles = recipe({});

  return (
    <chakra.div css={styles.root} cursor="default">
      {/* Hero image — recipe sizes it w:full h:auto, so the skeleton needs an
          explicit height to occupy the slot. ~16:9 of a 420px-max column. */}
      <Skeleton w="full" h="220px" />
      <Box css={styles.body}>
        <Skeleton h="3" w="50%" borderRadius="xs" />
        <Skeleton h="7" w="85%" borderRadius="xs" />
        <Skeleton mt="3" w="full" h="44px" borderRadius="full" />
      </Box>
    </chakra.div>
  );
}
